/** Even-odd ray casting — works on self-intersecting lasso paths. */
export function pointInPixelPoly(x: number, y: number, pts: Array<{ x: number; y: number }>): boolean {
  let inside = false;
  for (let i = 0, j = pts.length - 1; i < pts.length; j = i++) {
    const xi = pts[i].x;
    const yi = pts[i].y;
    const xj = pts[j].x;
    const yj = pts[j].y;
    const crosses = (yi > y) !== (yj > y) &&
      x < (xj - xi) * (y - yi) / ((yj - yi) || 1e-12) + xi;
    if (crosses) inside = !inside;
  }
  return inside;
}

export interface MapPoint {
  lat: number;
  lng: number;
}

export interface SelectionCounts {
  inShape: number;
  scheduled: number;
  available: number;
  ungeocodedTotal: number;
  scheduledByDay: Record<string, number>;
}

export function emptySelectionCounts(): SelectionCounts {
  return { inShape: 0, scheduled: 0, available: 0, ungeocodedTotal: 0, scheduledByDay: {} };
}
